<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Send Mode</v-card-title>

        <v-card-text>

            <v-select
                label="Send Mode"
                :items="$rc.enumChoices('auto_message_send_mode',false)"
                v-model="value_current"
            />

            <v-checkbox
                label="I have tested my message and am happy with the message and any attachments"
                v-model="test_acknowledgement"
                style="margin-right: 15px; margin-bottom: -25px"
                v-show="this.value_current == 'auto'"
                v-if="value_current == 'auto' && value_original != value_current"
            />

            <m-legal-checkbox-agreement
                type="auto-message-attestation"
                :organization_id="$route.params.organization_id"
                v-model="consent_acknowledgement"
                ref="bulk_message_attestation"
                v-show="this.value_current == 'auto'"
                v-if="value_current == 'auto' && value_original != value_current"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
                Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onChangeMode"
                :disabled="!can_change_mode"
            >
                Change Mode
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,

            value_original: null,
            value_current: null,

            consent_acknowledgement: false,
            test_acknowledgement: false,

        }
    },

    methods: {

        showDialog(value)
        {
            this.dialog = true;

            this.value_original = _.cloneDeep(value);
            this.value_current = _.cloneDeep(value);

            this.consent_acknowledgement = false;
            this.test_acknowledgement = false;
        },

        onChangeMode()
        {
            if ( this.value_current != 'auto' )
            {
                this.doChange();
                return;
            }

            if ( !this.consent_acknowledgement || !this.test_acknowledgement )
            {
                alert('You mush accept both check box agreements');
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/legal/sign-auto-message-attestation',
            
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'template_context': this.$route.params.template_context,
                    'template_subject_id': this.$route.params.template_subject_id,
                    },
            
                'on_success': (data) => {
                        this.doChange();
                    },
            
                'on_error': 'Unable to change automated message state',
            });
        },

        doChange()
        {
            this.dialog = false;
            this.$emit('change', this.value_current);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        can_change_mode() {
            if ( this.value_current == this.value_original )
                return false;

            if ( this.value_current == 'auto' )
            {
                if ( this.consent_acknowledgement == false )
                    return false;

                if ( this.test_acknowledgement == false )
                    return false;
            }

            return true;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>